import SignUpAdminData from './components/SignUpAdminData.vue'
import SignUpOrganizationData from './components/SignUpOrganizationData.vue'
import SignUpMarketRol from './components/SignUpMarketRol.vue'
import SignUpBuyerEstablishments from './components/SignUpBuyerEstablishments.vue'
import SignUpSellerEstablishments from './components/SignUpSellerEstablishments.vue'
import SignUpSentMessage from './components/SignUpSentMessage.vue'
import WeFile from '../WebExperto/components/WeFile.vue'
import WeFileUploader from '../WebExperto/components/WeFileUploader.vue'

const BcrSignUp = {
  install (Vue) {
    Vue.component('signup-admin-data', SignUpAdminData)
    Vue.component('signup-organization-data', SignUpOrganizationData)
    Vue.component('signup-market-rol', SignUpMarketRol)
    Vue.component('signup-buyer-establishments', SignUpBuyerEstablishments)
    Vue.component('signup-seller-establishments', SignUpSellerEstablishments)
    Vue.component('signup-sent-message', SignUpSentMessage)
    Vue.component('we-file', WeFile)
    Vue.component('we-file-uploader', WeFileUploader)
  }
}
// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(BcrSignUp)
}

export default BcrSignUp
export {
  SignUpAdminData,
  SignUpOrganizationData,
  SignUpMarketRol,
  SignUpBuyerEstablishments,
  SignUpSellerEstablishments,
  SignUpSentMessage,
  WeFile,
  WeFileUploader
}
